import Shipment from '../types/api/shipment'
import UploadedFile from '../types/api/uploaded-file'

export function sanitizeFilenameSegment(segment: string): string {
    return segment
        .replace(/[/\\:*?"<>|]/g, '_')
        .replace(/\s+/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_+|_+$/g, '')
        .slice(0, 120)
}

export function buildShipmentSourceDownloadFileName(
    clientName: string | undefined,
    shipmentId: number,
    originalFileName: string
): string {
    const client = sanitizeFilenameSegment(clientName || 'клиент')
    const shipment = String(shipmentId)
    const original = sanitizeFilenameSegment(originalFileName || 'файл')
    return `${client}_${shipment}_${original}`
}


export function* iterateShipmentSourceFiles(shipment: Shipment): Generator<UploadedFile> {
    const seenIds = new Set<number>()

    for (const file of shipment.sourceFile ?? []) {
        if (!file?.url || file.id == null || seenIds.has(file.id)) continue
        seenIds.add(file.id)
        yield file
    }

    for (const position of shipment.shipment_positions ?? []) {
        const file = position.sourceFile
        if (!file?.url || file.id == null || seenIds.has(file.id)) continue
        seenIds.add(file.id)
        yield file
    }
}
